import { useTracking } from 'dashboard/composables/useTracking';
import {
  defaultAnalyticsHandlers,
  dispatchAnalytics,
} from 'dashboard/helper/lais/analyticsHandlers';

const resolveDefaultProps = (defaultProps, state) =>
  typeof defaultProps === 'function' ? defaultProps(state) : defaultProps || {};

export const trackStoreAction = (
  action,
  state,
  {
    handlers = defaultAnalyticsHandlers,
    tracking = useTracking(),
    defaultProps = {},
    enabled = true,
  } = {}
) => {
  if (!enabled) return null;

  return dispatchAnalytics(action, {
    handlers,
    track: tracking.track,
    defaultProps: resolveDefaultProps(defaultProps, state),
    state,
  });
};

export const createAnalyticsTrackerPlugin =
  (options = {}) =>
  store => {
    if (typeof store.subscribeAction === 'function') {
      store.subscribeAction({
        after: (action, state) => trackStoreAction(action, state, options),
      });
    }

    if (typeof store.subscribe === 'function') {
      store.subscribe((mutation, state) =>
        trackStoreAction(
          {
            type: mutation.type,
            payload: mutation.payload,
            source: 'mutation',
          },
          state,
          options
        )
      );
    }
  };

export const createPiniaAnalyticsTrackerPlugin =
  (options = {}) =>
  ({ store }) => {
    store.$onAction(({ name, args, after }) => {
      after(result =>
        trackStoreAction(
          {
            type: `${store.$id}/${name}`,
            payload: args?.[0],
            result,
            storeId: store.$id,
          },
          store.$state,
          options
        )
      );
    });
  };

export default createAnalyticsTrackerPlugin;
